import { render } from "./ReplacementOverlay.vue?vue&type=template&id=7b84e5bf&scoped=true"
import script from "./ReplacementOverlay.vue?vue&type=script&lang=js"
export * from "./ReplacementOverlay.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7b84e5bf"

export default script